
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired078"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired078"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8deQh", function(module, exports) {

$parcel$export(module.exports, "default", () => $4966f470bf4aa287$export$2e2bcd8739ae039);
class $4966f470bf4aa287$var$AppCoordinator {
    #window;
    constructor(window1){
        this.#window = window1;
    }
    start() {}
    coordinatorDidFinish(source) {
        let coordinator = source.constructor.NAME;
        switch(coordinator){
            case "WelcomeCoordinator":
                window.location.href = "/game.html";
                break;
            case "GameCoordinator":
                window.location.href = "/score.html";
                break;
            case "ScoreCoordinator":
                window.location.href = "/";
                break;
            default:
                console.error("Cannot handle coordinatorDidFinish() from " + coordinator);
        }
    }
}
var $4966f470bf4aa287$export$2e2bcd8739ae039 = $4966f470bf4aa287$var$AppCoordinator;

});


var $8deQh = parcelRequire("8deQh");
class $a9c37f2c6f0ac0f7$var$WelcomeViewController {
    #viewModel;
    #document;
    #cardElement;
    constructor(document){
        this.#document = document;
        this.#cardElement = document.querySelector("#welcome-card");
    }
    set viewModel(value) {
        this.#viewModel = value;
    }
    renderView() {
        this.#armStartButton();
    }
    #armStartButton() {
        let button = this.#cardElement.querySelector("#welcome-card-start-button");
        button.addEventListener("click", this.#didClickStartButton.bind(this));
    }
    #didClickStartButton(event) {
        this.#viewModel.startGame();
    }
}
var $a9c37f2c6f0ac0f7$export$2e2bcd8739ae039 = $a9c37f2c6f0ac0f7$var$WelcomeViewController;


class $f56a8768c53f6e56$var$WelcomeViewModel {
    #model;
    #coordinatorDelegate;
    #viewDelegate;
    constructor(){}
    set model(value) {
        this.#model = value;
    }
    set coordinatorDelegate(value) {
        this.#coordinatorDelegate = value;
    }
    set viewDelegate(value) {
        this.#viewDelegate = value;
    }
    startGame() {
        let callback = (function() {
            this.#coordinatorDelegate.viewModelDidFinish();
        }).bind(this);
        this.#model.startGame(callback);
    }
}
var $f56a8768c53f6e56$export$2e2bcd8739ae039 = $f56a8768c53f6e56$var$WelcomeViewModel;


class $fdabe2b0e4c11508$var$WelcomeModel {
    #storage;
    constructor(){
        this.#storage = window.localStorage;
    }
    startGame(callback) {
        this.#storage.setItem("stats.cards", 0);
        this.#storage.setItem("stats.answers.correct", 0);
        this.#storage.setItem("stats.answers.wrong", 0);
        callback();
    }
}
var $fdabe2b0e4c11508$export$2e2bcd8739ae039 = $fdabe2b0e4c11508$var$WelcomeModel;


class $811fbd379ac720db$var$WelcomeCoordinator {
    #delegate;
    #window;
    static NAME = "WelcomeCoordinator";
    constructor(window){
        this.#window = window;
    }
    set delegate(value) {
        this.#delegate = value;
    }
    start() {
        let viewController = new (0, $a9c37f2c6f0ac0f7$export$2e2bcd8739ae039)(this.#window.document);
        let viewModel = new (0, $f56a8768c53f6e56$export$2e2bcd8739ae039)();
        viewController.viewModel = viewModel;
        viewModel.model = new (0, $fdabe2b0e4c11508$export$2e2bcd8739ae039)();
        viewModel.coordinatorDelegate = this;
        viewModel.viewDelegate = viewController;
        viewController.renderView();
    }
    viewModelDidFinish() {
        this.#delegate.coordinatorDidFinish(this);
    }
}
var $811fbd379ac720db$export$2e2bcd8739ae039 = $811fbd379ac720db$var$WelcomeCoordinator;


window.addEventListener("load", function() {
    let coordinator = new (0, $811fbd379ac720db$export$2e2bcd8739ae039)(this);
    coordinator.delegate = new (0, $8deQh.default)(this);
    coordinator.start();
});


//# sourceMappingURL=index.552c61d6.js.map
